import React from 'react'
import Navbar from './Navbar'

const Experience = () => {
    return (
        <section className="resume-section" id="experience">
            <Navbar />
            <div className="resume-section-content">
                <h2 className="mb-5">Experience</h2>
                <div className="d-flex flex-column flex-md-row justify-content-between mb-5">
                    <div className="flex-grow-1">
                        <h3 className="mb-0 text-warning">Senior Full-Stack Developer</h3>
                        <div className="subheading mb-3">Srijan Technologies</div>
                        <p>Srijan is a digital experience services company that helps global Fortune 500s to nonprofits build transformative digital paths to a better future.</p>
                        <h3>Role</h3>
                        <ul class="list-group">
                            <li class="list-group-item">Integrating 3rd APIs in our project.</li>
                            <li class="list-group-item">Creating unified REST APIs.</li>
                            <li class="list-group-item">Develop and create queries in our backend.</li>
                        </ul>
                    </div>
                    <div className="flex-shrink-0"><span className="text-primary">April 2021 - Present</span></div>
                </div>

                <div className="d-flex flex-column flex-md-row justify-content-between mb-5">
                    <div className="flex-grow-1">
                        <h3 className="mb-0 text-danger">Senior Web App Developer</h3>
                        <div className="subheading mb-3">eResolute</div>
                        <p>eResolute Payment Services Provider LLC is a futuristic fintech company with a core focus on
                            aggregating billers
                            globally. We have a global customer base and have processed more than 1 billion transactions
                            through our platforms.
                            We have integrated more than 1,000 APIs using our state of the art technology. Headquartered
                            in Dubai with operations
                            across the globe and a strong technological back end in India, we maintain a strong
                            relationship with external
                            stakeholders.</p>
                        <h3>Role</h3>
                        <ul class="list-group">
                            <li class="list-group-item">Analysis of 3rd party API documentation.</li>
                            <li class="list-group-item">Integrating 3rd APIs to avail the services offered by them in our application.</li>
                            <li class="list-group-item">Creating unified REST APIs.</li>
                            <li class="list-group-item">Develop and improve features for different areas in our backend.</li>
                        </ul>

                    </div>
                    <div className="flex-shrink-0"><span className="text-primary">January 2017 - April 2021</span></div>
                 </div>
                  <div className="d-flex flex-column flex-md-row justify-content-between mb-5">
                    <div className="flex-grow-1">
                        <h3 className="mb-0">Web App Developer</h3>
                        <div className="subheading mb-3">Infahs Apple</div>
                        <p>Authorized Apple Service Center. They Provide Service to Apple Products. </p>
                    </div>
                    <div className="flex-shrink-0"><span className="text-primary">April 2016 - Sep 2016</span></div>
                </div>
            </div>
        </section>
    )
}
export default Experience
